<template>
    <div id="lt-yantr" class="insurance yantr-tracking">
        <div class="container-fluid fadeInBlock yantr-bullseye green-gradient">
            <div class="container">
                <h2><span class="lt4-Insurance"></span>{{ Headline }}</h2>
                <ul class="disclosure">
                    <li><span class="lt4-Lock"></span></li>
                    <li>Privacy secured</li>|
                    <li><advertising-disclosures :disclosure-text="DisclosureText" :disclosure-tokens="DisclosureTokens" /></li>
                </ul>
            </div>
        </div>
        <div class="results-section">
            <div class="container">
                <insurance-results
                    :insured-label="insuredLabel"
                    :insurance-type-label="insuranceTypeLabel"
                    :zipcode-label="zipcodeLabel"
                    :currently-insured="CurrentlyInsured"
                    :zip-code="ZipCode"
                    :popup-submit="PopupSubmit"
                    :city="City"
                    :state="State"
                />
            </div>
        </div>
        <insurance-zip-code-popup
            :zip-code="zipCode"
            :currently-insured="currentlyInsured"
            :show-modal="true"
            :popup-title="PopupTitle"
            @submit="update"
        />
    </div>
</template>

<script>
    import insuranceZipCodePopup from './components/insurance-zip-code-popup.vue';
    import AdvertisingDisclosures from '~/components/advertising-disclosures.vue';
    import InsuranceResults from './components/insurance-results.vue';

    export default {
        props: {
            zipCode: {
                default: '',
            },
            currentlyInsured: {
                default: null,
            },
            headline: {
                default: 'Your insurance results',
            },
            disclosureText: {
                default: 'Advertising Disclosures',
            },
            disclosureTokens: {
                default: '00032',
            },
            zipcodeLabel: {
                default: 'Zip Code',
            },
            insuredLabel: {
                default: 'Currently Insured?',
            },
            insuranceTypeLabel: {
                default: 'Insurance Type',
            },
            popupTitle: {
                default: 'Just two quick questions before we get your quotes.',
            },
        },
        data() {
            return {
                ZipCode: this.zipCode,
                CurrentlyInsured: this.currentlyInsured,
                Headline: this.headline,
                DisclosureText: this.disclosureText,
                DisclosureTokens: this.disclosureTokens,
                PopupSubmit: 'false',
                City: this.city,
                State: this.state,
                PopupTitle: this.popupTitle,
            };
        },
        methods: {
            update(res) {
                this.ZipCode = res.zipCode;
                this.CurrentlyInsured = res.insured ? 'Yes' : 'No';
                this.PopupSubmit = 'true';
                this.City = res.city;
                this.State = res.state;
            },
        },
        computed: {
        },
        components: {
            insuranceZipCodePopup,
            AdvertisingDisclosures,
            InsuranceResults,
        },
    };
</script>
<style src="../../assets/styles/common.scss" lang="scss"></style>
<style src="./main.scss" lang="scss"></style>
